module.exports = __webpack_public_path__ + "static/kleurplaat-d0b747d816f433158c35df8964c39337.jpg";